import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.SUBMISSION = (state, payload) => {
  const row = state.row
  const questions = row.questions
  payload.answers = []
  payload.m0601_id = row.id
  questions.forEach((q, i) => {
    const obj = { m0601_id: row.id, m0602_id: q.id, ques_type: q.type }
    let tmp
    if (q.type === 0) { // Multiple Choice
      obj.choice = ''
      tmp = payload.raw_answers.find(a => a.m0602_id === q.id)
      if (tmp) {
        obj.choice = tmp.m0603_id
      }
    } else if (q.type === 1) { // Checkboxes
      obj.choices = payload.raw_answers.filter(a => a.m0602_id === q.id).map(a => a.m0603_id)
    } else if (q.type === 2) { // Text Answer
      obj.text = ''
      tmp = payload.raw_answers.find(a => a.m0602_id === q.id)
      if (tmp) {
        obj.text = tmp.text
      }
    }
    payload.answers.push(obj)
  })
  state.submission = Object.assign({}, state.submission, payload)
}

const state = {
  rows: [],
  row: null,
  submission: {
    email: '',
    name: '',
    answers: []
  }
}

const actions = {
  init: ({ commit }, row) => {
    return client.postData({ data: { find: { api: 'M0611SurveySubmissionService.getSubmissions', input: row } } })
      .then((data) => {
        const output = data.find.output
        commit('FIND_ALL', output.rows)
        commit('EDIT', output.row)
        if (!output.row) {
          SysUtils.showError('No survey form record found')
        }
        if (output.rows.length === 0) {
          SysUtils.showInfo('No submission yet')
        }
      })
  },
  getUserSubmission: ({ commit }, row) => {
    return client.postData({ data: { find: { api: 'M0611SurveySubmissionService.getUserSubmission', input: row } } })
      .then((data) => {
        const output = data.find.output
        commit('SUBMISSION', output)
      })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
